import * as types from "../types/delivery";

const INITIAL_STATE = {
  delivery_loading: false,
  delivery_configuracao: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_DELIVERY_CONFIGURACAO:
      return { ...state, delivery_configuracao: action.payload };
    case types.SET_LOADING_DELIVERY_CONFIGURACAO:
      return { ...state, delivery_loading: action.payload };
    default:
      return state;
  }
};
